
import React from 'react';
import { FC } from 'react';
import SvgIconValues from './SvgIconValues'
import colors from '../../globals/colors';

export interface SvgIcon extends FC<SvgIconValues> { }


export const Fb: SvgIcon = ({
    fill = colors.primary,
    height = '1em',
    fontSize = '1.3928571428571428rem',
    stroke = 'none',
    strokeWidth = 1,
}): JSX.Element => {
    return (
        <svg
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
            fill={fill}
            height={height}
            fontSize={fontSize}
        >
            <g
                stroke={stroke}
                strokeWidth={strokeWidth}
                fill='none'
                fillRule="evenodd">
                <path d="M12.7171122,19.0909091 L10.0566773,19.0909091 L10.0566773,12.81739 L8.72727273,12.81739 L8.72727273,10.6557458 L10.0566773,10.6557458 L10.0566773,9.35796746 C10.0566773,7.59460421 10.8069313,6.54545455 12.9398312,6.54545455 L14.7150801,6.54545455 L14.7150801,8.70789057 L13.6055495,8.70789057 C12.7752305,8.70789057 12.7203636,9.00996649 12.7203636,9.57373597 L12.7167058,10.6557458 L14.7272727,10.6557458 L14.4919547,12.81739 L12.7167058,12.81739 L12.7167058,19.0909091 L12.7171122,19.0909091 Z" fill="currentColor"></path>
            </g>
        </svg>
    );
};

export const Linkedin: SvgIcon = ({
    fill = colors.primary,
    height = '1em',
    fontSize = '1.3928571428571428rem',
    stroke = 'none',
    strokeWidth = 1,
}): JSX.Element => {
    return (
        <svg
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
            fill={fill}
            height={height}
            fontSize={fontSize}
        >
            <g
                stroke={stroke}
                strokeWidth={strokeWidth}
                fill='none'
                fillRule="evenodd">
                <path
                    d="M6.82061917,10.0435162 L8.9468913,10.0435162 L8.9468913,17.453847 L6.82061917,17.453847 L6.82061917,10.0435162 Z M7.82955614,9.1166137 L7.81416232,9.1166137 C7.04447105,9.1166137 6.54545455,8.55013446 6.54545455,7.83278036 C6.54545455,7.10075787 7.05922347,6.54545455 7.84430856,6.54545455 C8.62875224,6.54545455 9.11109211,7.09936088 9.12648593,7.83068487 C9.12648593,8.54803898 8.62875224,9.1166137 7.82955614,9.1166137 L7.82955614,9.1166137 Z M17.4545455,17.4545455 L15.0434876,17.4545455 L15.0434876,13.6191108 C15.0434876,12.6153739 14.6663388,11.930849 13.8369965,11.930849 C13.2026426,11.930849 12.8498674,12.392554 12.6856666,12.8388922 C12.6240913,12.998149 12.6337125,13.2209688 12.6337125,13.4444871 L12.6337125,17.4545455 L10.2451039,17.4545455 C10.2451039,17.4545455 10.2758916,10.6609856 10.2451039,10.0435162 L12.6337125,10.0435162 L12.6337125,11.20651 C12.7748225,10.6980058 13.5380997,9.97226976 14.7561361,9.97226976 C16.2672967,9.97226976 17.4545455,11.0388712 17.4545455,13.3334265 L17.4545455,17.4545455 L17.4545455,17.4545455 Z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};

export const Mail: SvgIcon = ({
    fill = colors.primary,
    height = '1em',
    fontSize = '1.3928571428571428rem'

}): JSX.Element => {
    return (
        <svg
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
            fill={fill}
            height={height}
            fontSize={fontSize}
        >
            <g>
                <path fill='none' d="M6.8,1.1h10v10h-10V1.1z" />
                <path fill="#2E8FFA" d="M17.8,6.2H6.3c-0.9,0-1.4,0.7-1.4,1.5v8.6c0,0.7,0.5,1.4,1.4,1.4h11.5c0.7,0,1.4-0.7,1.4-1.4V7.7
		C19.2,6.8,18.5,6.2,17.8,6.2z M17.8,16.3H6.3V9.1l5.7,3.6l5.7-3.6v7.2H17.8z M12,11.1L6.3,7.7h11.5L12,11.1z"/>
            </g>
        </svg>
    );
};

export const Print: SvgIcon = ({
    fill = colors.primary,

}): JSX.Element => {
    return (
        <svg width="14" height="14" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.1764 7.04512H19.9764V0.378448H5.57637V7.04512H4.37637C2.38437 7.04512 0.776367 8.83178 0.776367 11.0451V19.0451H5.57637V24.3784H19.9764V19.0451H24.7764V11.0451C24.7764 8.83178 23.1684 7.04512 21.1764 7.04512ZM7.97637 3.04512H17.5764V7.04512H7.97637V3.04512ZM17.5764 19.0451V21.7118H7.97637V16.3784H17.5764V19.0451ZM19.9764 16.3784V13.7118H5.57637V16.3784H3.17637V11.0451C3.17637 10.3118 3.71637 9.71178 4.37637 9.71178H21.1764C21.8364 9.71178 22.3764 10.3118 22.3764 11.0451V16.3784H19.9764Z" fill={fill} />
        </svg>

    );
};

export const FalseIcon: SvgIcon = (): JSX.Element => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.67982 16H14.3202C15.6128 16 16.4185 14.4289 15.7722 13.1777L9.45205 0.93841C8.80576 -0.312803 7.19424 -0.312803 6.54795 0.93841L0.227771 13.1777C-0.418516 14.4289 0.387244 16 1.67982 16ZM8 9.41467C7.53837 9.41467 7.16067 8.99133 7.16067 8.47391V6.59239C7.16067 6.07497 7.53837 5.65162 8 5.65162C8.46163 5.65162 8.83933 6.07497 8.83933 6.59239V8.47391C8.83933 8.99133 8.46163 9.41467 8 9.41467ZM8.83933 13.1777H7.16067V11.2962H8.83933V13.1777Z" fill={colors.danger} />
        </svg>

    );
};
export const CorrectIcon: SvgIcon = (): JSX.Element => {
    return (<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.28888 0.288887C3.87288 0.288887 0.288879 3.87289 0.288879 8.28889C0.288879 12.7049 3.87288 16.2889 8.28888 16.2889C12.7049 16.2889 16.2889 12.7049 16.2889 8.28889C16.2889 3.87289 12.7049 0.288887 8.28888 0.288887ZM6.12088 11.7209L3.24888 8.84889C2.93688 8.53689 2.93688 8.03289 3.24888 7.72089C3.56088 7.40889 4.06488 7.40889 4.37688 7.72089L6.68888 10.0249L12.1929 4.52089C12.5049 4.20889 13.0089 4.20889 13.3209 4.52089C13.6329 4.83289 13.6329 5.33689 13.3209 5.64889L7.24888 11.7209C6.94488 12.0329 6.43288 12.0329 6.12088 11.7209Z" fill={colors.sucess} />
    </svg>
    )
}